// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"6752fe3a","626":"75e5efcf"}[chunkId] + ".chunk.js";
};